<template>
  <div
    class="payment-methods-container"
    style="border: solid 2px rgba(0, 0, 0, 0.1); padding: 25px"
  >
    <div class="input-mask-label">{{ $translation($websiteText().checkout_payment_method_card_number) }}</div>
    <div>
      <!-- <input-mask
        style="width: 24%"
        v-model="cardDetail.num1"
        mask="9999"
        placeholder="1234"
      />
      &nbsp; &nbsp;
      <input-mask
        style="width: 24%"
        v-model="cardDetail.num2"
        mask="9999"
        placeholder="1234"
      />
      &nbsp; &nbsp;
      <input-mask
        style="width: 24%"
        v-model="cardDetail.num3"
        mask="9999"
        placeholder="1234"
      />
      &nbsp; &nbsp;
      <input-mask
        style="width: 24%"
        v-model="cardDetail.num4"
        mask="9999"
        placeholder="1234"
      /> -->
      <div class="p-inputmask" id="card-element"></div>
    </div>
    <br />
    <div class="input-mask-label">{{$translation($websiteText().checkout_payment_method_card_holder_name)}}</div>
    <input-text v-model="cardDetail.name" placeholder="John Doe" />
    <div class="input-mask-label">{{$translation($websiteText().checkout_payment_method_expiration)}}</div>
     <div >
      <!--<input-text
        style="max-width: 150px"
        type="number"
        v-model="cardDetail.expMonth"
        placeholder="MM"
      />
      &nbsp;
      <input-text
        style="max-width: 150px"
        type="number"
        v-model="cardDetail.expYear"
        placeholder="YY"
      /> -->
      <div class="p-inputmask" id="card-expiry"></div>

    </div>
    <div class="input-mask-label">{{$translation($websiteText().checkout_payment_method_cvc)}}</div>
    <!-- <input-text
      style="width: 150px"
      v-model="cardDetail.cvc"
      :placeholder="$translation($websiteText().checkout_payment_method_cvc)"
      type="number"
    /> -->
    <div class="p-inputmask" id="card-cvc"></div>

    <br />
    <div class="d-flex flex-column mb-2" style="margin-top: 15px">
      <t-checkbox
        v-model="transferInfo.agree1"
        name="agree"
        :label="$translation($websiteText().checkout_payment_method_waiting_for_availability_confirmation_checkbox)"
      />
    </div>
    <div class="d-flex mb-2" style="margin-top: 15px">
      <t-checkbox v-model="transferInfo.agree2" name="agree" :label="$translation($websiteText().checkout_payment_method_agree)" />
      <div class="terms" @click="goToTerms()">{{$translation($websiteText().checkout_payment_method_terms_of_use)}}</div>
    </div>

    <div class="card-submit-class">
      <t-button
        :disabled="!transferInfo.agree2 || !transferInfo.agree1 || !canPay"
        style="margin-left: auto; margin-top: 10px"
        :icon="'pi pi-credit-card'"
        :label="$translation($websiteText().checkout_payment_method_pay_by_card)"
        @click="submit"
        color="primary-color"
        :buttonClass="'card-submit-btn'"
      />
      &nbsp;
      <div class="card-bottom-info">
        <span class="price-class">{{ $store.getters.currency.symbol + amount }}</span>
        <span class="fees-class">{{$translation($websiteText().checkout_payment_method_credit_card_fees)}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import TButton from "../../../../../common/components/buttons/TButton.vue";
import {reactive} from "@vue/reactivity";
import {computed} from "@vue/runtime-core";
import {toRefs} from 'vue';
import TCheckbox from "../../../../../common/components/controls/TCheckbox.vue";
import {defineAsyncComponent} from "vue";
const InputMask = defineAsyncComponent(() => import("primevue/inputmask"));
import InputText from "../../../../../common/components/input-text/TInputText.vue";
import {loadStripe} from '@stripe/stripe-js'
import GeneralVariables from "../../../../../common/utils/GeneralVariables";
import { DONE, PENDING, SHOW_TOAST_MESSAGE } from "../../../../../common/store/actions";
import GeneralHelper from "../../../../../common/helpers/GeneralHelper";
let elements
let cardElement
let cardExpiryElement
let cardCVCElement
let stripe

async function getToken()
{
  const token = await stripe.createToken(cardElement)
  if (token&&token.token)
    return token.token.id
  else
    return null
}

export default {
  components: {
    TButton,
    TCheckbox,
    InputText,
    // InputMask,
  },
  async mounted()
  {
    
    const appearance = { /* appearance */ };
    const options = {
    
    }
    

    loadStripe(GeneralVariables.STRIPE_PUBLISHABLE_KEY).then(
    (result)=>{
      stripe = result
      elements = stripe.elements({ appearance })
      cardElement = elements.create('cardNumber', options);
      cardExpiryElement = elements.create('cardExpiry', options);
      cardCVCElement = elements.create('cardCvc', options);

      cardElement.mount('#card-element');
      cardExpiryElement.mount('#card-expiry');
      cardCVCElement.mount('#card-cvc');
    }
  ) 

  },

  setup(props) {
    let buttonMessageText = reactive({value: props.buttonMessage});
    const amount = computed(() => props.total);

    let cardDetail = reactive({
      num1: "",
      num2: "",
      num3: "",
      num4: "",
      name: "",
      cvc: "",
      expMonth: "",
      expYear: "",
    });

    
    const splitCardNumber = (event) => {
      const input = event.replace(/\D/g, '');
      const cardNumArr = input.match(/.{1,4}/g);
      if (cardNumArr) {
        cardDetail.num1 = cardNumArr[0];
        cardDetail.num2 = cardNumArr[1] || '';
        cardDetail.num3 = cardNumArr[2] || '';
        cardDetail.num4 = cardNumArr[3] || '';
      }
    };
 

    let transferInfo = reactive({agree1: false, agree2: false});
    return {
      transferInfo, 
      cardDetail, 
      buttonMessageText, 
      amount, 
      splitCardNumber,
      
    };

  },

  data() {
    return {
      publishableKey: process.env.STRIPE_PUBLISHABLE_KEY,
      token: null,
      stripe: null,
      clientSecret: null,
    };
  },
  methods: {
    async submit() {
      this.$store.dispatch(PENDING)
      const token = await getToken()
      if (token)
      {
        this.paymentDoneAction(token);
      }
      else
      {
        this.$store.dispatch(SHOW_TOAST_MESSAGE, GeneralHelper.buildMessage(3, "Invalid Card Details"))
        this.$store.dispatch(DONE)
      }
    },
    goToTerms() {
      let route = this.$router.resolve({
        name: "terms",
      });
      window.open(route.href, "_blank");
    },
    getToken() {},
  },
  props: {
    buttonMessage: {
      default: "PAY BY CARD",
    },
    total: Number,
    currency: String,
    paymentDoneAction: Function,
  },
  computed: {
    canPay() {
      return this.$store.getters.status_id == 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.InputElement {
  height: 50px !important;
  font-size: 32px !important;
}

.p-inputmask {
  background: white !important;
  border-radius: 4px !important;
  border: 1px solid $border-color !important;
  padding: 10px !important;
  height: 42px !important;
}

.input-mask-label {
  color: black;
  @include f-label;
}

.terms {
  @include f-button;
  cursor: pointer;
  text-align: flex-start;
  padding-left: 5px;
  text-decoration: underline !important;
  font-size: 15px;
}

.price-class {
  @include f-price;
  color: $secondary-color;
  margin-left: 10px;
  margin-top: 10px;
  margin-right: 10px;
}

.fees-class {
  color: $light-black;
  @include f-button;
  text-align: right;
}

.card-bottom-info {
  margin-top: 10px;
}

@media screen and (max-width: 768px) {
  ::v-deep .card-submit-class {
    display: flex;
    flex-direction: column-reverse;
    .card-submit-btn {
      width: 100% !important;
    }
    .card-bottom-info {
      width: 100% !important;
    }
  }
}
</style>
